import React, { lazy, Suspense } from 'react';
import { isDesktop, isMobile } from 'react-device-detect';
import { createGlobalStyle } from 'styled-components';
import { Box } from '@mui/material';

import DashboardContent from '@core/dashboard/components/DashboardContent';
import DashboardBarButtons from '@core/dashboard/components/DashboardBarButtons';
import EventDrawer from '@core/dashboard/components/EventDrawer';
import PoiPreview from '@core/dashboard/components/PoiPreview';
import LeaveRegionDialog from '@core/dashboard/components/LeaveRegionDialog';
import TeleportToRoomDialog from '@core/dashboard/components/TeleportToRoomDialog';
import AdminSettings from '@core/dashboard/components/AdminSettings';
import DolbyCameraDialog from '@core/dashboard/components/DolbyCameraDialog';
import OrientationOverlay from '@core/dashboard/components/OrientationOverlay';
import { useShowOrientationOverlay } from '@core/dashboard/components/OrientationOverlay/hooks';
import MapModal from '@core/dashboard/components/MapModal/MapModal';
import { IEventPageView } from './interfaces';

import { useStyles } from './styles';
import { useEventContext } from '@providers/EventProvider';
import { env } from 'env';
import { useMytaverseEvent } from '@core/dashboard/providers';
import LoadingProgress from '@components/LoadingProgress';
import MobileExternalKeyboardControls from '@components/VideoGameCast/MobileExternalKeyboardControls';
const ZoomScreenPreview = lazy(
  () => import('@features/zoom/components/ZoomScreenPreview'),
);
const Avaturn = lazy(() => import('@features/avaturn/components/AvaturnModal'));

const GlobalStyle = createGlobalStyle`
  body {
      background-color: #000000;
  }
`;

const { REACT_APP_FEATURE_AVATURN } = env;

const EventPageView = ({ openAdminSettingsModal }: IEventPageView) => {
  const { showOverlay, isLandscape, handleHideOverlay } =
    useShowOrientationOverlay();
  const { isEventRun } = useEventContext();
  const {
    showAvaturnModal,
    // showExternalKeyboardOverlay,
    externalKeyboardConnected,
  } = useMytaverseEvent();

  const classes = useStyles(showOverlay, isEventRun);

  const screenPreview = () => {
    switch (env.REACT_APP_FEATURE_THIRD_PARTY_COMMUNICATIONS_PROVIDER) {
      case 'ZOOM':
        return (
          <Suspense>
            <ZoomScreenPreview />
          </Suspense>
        );

      default:
        return (
          <>
            <video
              id="screen-share-content-video"
              style={classes.video(isDesktop)}
            ></video>
            <canvas
              id="screen-share-content-canvas"
              style={classes.video(isDesktop)}
            ></canvas>
          </>
        );
    }
  };

  return (
    <>
      {screenPreview()}
      {/*<SpeedTestCheck />*/}
      <Box id="home" sx={classes.homePage}>
        <DashboardBarButtons />
        <EventDrawer />
        <Box sx={classes.root}>
          <DashboardContent />
          <PoiPreview />
          <LeaveRegionDialog />
          <TeleportToRoomDialog />
          <DolbyCameraDialog />
          <MapModal />
          {openAdminSettingsModal && <AdminSettings />}
        </Box>
      </Box>
      {showOverlay && (
        <OrientationOverlay
          isButton={isLandscape}
          onClick={handleHideOverlay}
        />
      )}
      {/*{showExternalKeyboardOverlay && <ExternalKeyboardOverlay />}*/}
      {!isDesktop && externalKeyboardConnected ? (
        <MobileExternalKeyboardControls />
      ) : (
        ''
      )}
      {showAvaturnModal && REACT_APP_FEATURE_AVATURN === 'true' ? (
        <Suspense fallback={<LoadingProgress />}>
          <Avaturn />
        </Suspense>
      ) : null}
      {isEventRun && isMobile && isLandscape && !showOverlay ? (
        <GlobalStyle />
      ) : null}
    </>
  );
};

export default EventPageView;
